import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./DividerVertical.module.scss";

const DividerVertical = ({className}) => {
  return (
    <div className={classNames(styles["root"], className)} />
  );
};

DividerVertical.propTypes = {
  className: PropTypes.string,
};

export default DividerVertical;
